import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.SALE_SET_SALES_REGISTER_CONFIRM_DIALOG]: (state, payload) => {
    state.salesRegisterConfirmDialog = payload.show
  },
  [mutationsTypes.SALE_SET_SALE_HISTORY]: (state, payload) => {
    state.meta = 'meta' in payload ? payload.meta : null
    state.summary = payload.data.summary
    state.saleList = payload.data.saleList
  },
  [mutationsTypes.SALE_SET_SALE_PAYMENT_LIST]: (state, payload) => {
    state.salePaymentList = payload.paymentList
  },
  [mutationsTypes.SALE_SET_RACKNUMBER_BY_PRODUCT]: (state, payload) => {
    state.rackNumberByProduct = payload.productList
  },
  [mutationsTypes.SALE_SET_SALE_DETAIL]: (state, payload) => {
    state.saleDetail = payload.saleList
  },
  [mutationsTypes.SALE_BULK_OPERATION_FLG]: (state, flag) => {
    state.bulkOperationCompleted = flag
  }
}

export default Mutations
